import React from 'react';
import { Helmet } from 'react-helmet';

function Finish_Seo() {
    return (
        <div>
            <Helmet>
                <title>Complete onboarding process in less than a minute with IDScan | Ifepay</title>
                <meta name="description" content="Easy and quick KYC confirms that now you are ready to make your first transfer. Get started today." />
                <meta property="og:title" content="Complete onboarding process in less than a minute with IDScan | Ifepay" />
                <meta property="og:description" content="Easy and quick KYC confirms that now you are ready to make your first transfer. Get started today." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/finish"/>
            </Helmet>
        </div>
    )
}

export default Finish_Seo
